import React, {
    useCallback,
    useContext,
    useEffect,
    useMemo,
    useRef,
    useState,
} from 'react'
import Hexagon from '../../Login/Hexagon/Hexagon'
import HexagonItem from '../HexagonItem/HexagonItem'
import classes from './HexagonBoard.module.css'
import AuthContext from '../../../store/auth/auth-context'
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch'
import PropTypes from 'prop-types'
import Close from '../Close/Close'
import BoardContext from '../../../store/board/board-context'
import HexContext from '../../../store/hex/hex-context'

const HexagonBoard = React.forwardRef((props, ref) => {
    const { ref1, ref2 } = ref
    const panningRef = useRef()
    const [popupActive, setPopupActive] = useState(false)
    const authCtx = useContext(AuthContext)
    const boardCtx = useContext(BoardContext)
    const hexCtx = useContext(HexContext)
    const [panningDisabled, setPanningDisabled] = useState(false)
    const [isPanning, setIsPanning] = useState(false)
    const [minZoom, setMinZoom] = useState(1)
    const [dropZoneIndex, setDropZoneIndex] = useState()
    const [isMobile, setIsMobile] = useState(false)
    const popupHandler = useCallback(() => {
        setPopupActive(!popupActive)
    }, [popupActive])

    const panningHandler = useCallback((state) => {
        setPanningDisabled(state)
    }, [])
    // let content = null
    // const preventPan = (event) => {
    //     // if the target is the content container then prevent panning
    //     if (event.target === content) {
    //
    //         return true
    //     }
    // }

    useEffect(() => {
        if (window.innerWidth < 641) {
            setMinZoom(0.5)
        }
        if (window.innerWidth < 768) {
            setIsMobile(true)
        }
    }, [])
    const onlineCheck = sessionStorage.getItem('onlineCheck')

    const getBorders = useMemo(() => {
        const borderSize = 38
        let borderListTop = []
        let borderListBottom = []
        let borderListLeft = []
        let borderListRight = []
        let borders = [
            { name: 't', array: borderListTop },
            { name: 'b', array: borderListBottom },
            {
                name: 'l',
                array: borderListLeft,
            },
            { name: 'r', array: borderListRight },
        ]
        let col = 1
        for (let i = 1; i <= borderSize; i++) {
            borders.forEach((item) => {
                return (item.array = [
                    <div
                        key={item.name + i}
                        style={{ gridColumn: col + '/span 3' }}
                        className={classes.hex}
                    >
                        <div className={classes.box} />
                        <div className={classes.overlay} />
                    </div>,
                    ...item.array,
                ])
            })

            col += 2
        }
        return borders
    }, [])
    return (
        <section
            ref={ref1}
            id="hexagonCanvas"
            className={`${classes.board} ${classes[authCtx.menuToggle]} ${
                authCtx.shareMode && classes.share
            } ${hexCtx.focusedHex && isMobile && classes.keyboardOpen}`}
        >
            {/*<button onClick={() => exportAsImage(ref.current, "test")}> test Image</button>*/}
            <TransformWrapper
                initialScale={1.5}
                minScale={minZoom}
                doubleClick={{ disabled: true }}
                disabled={panningDisabled}
                pinch={{ step: 0.3 }}
                wheel={{ step: 0.05 }}
                centerOnInit={true}
            >
                {({
                    zoomToElement,
                    zoomIn,
                    zoomOut /* resetTransform */,
                    state,
                    setTransform,
                }) => (
                    <React.Fragment>
                        <img
                            id="dragCursor"
                            className={classes.dragCursor}
                            src={require('../../../assets/drag.png')}
                        />
                        <div className={classes.tools}>
                            <button
                                className={classes.zoom}
                                onClick={() => zoomIn()}
                            >
                                +
                            </button>
                            <button
                                className={classes.zoom}
                                onClick={() => zoomOut()}
                            >
                                -
                            </button>
                            <p className={classes.saveText}>
                                {boardCtx.saving.status
                                    ? boardCtx.saving.message
                                    : null}
                            </p>
                        </div>
                        <div className={classes.offline}>
                         {onlineCheck === 'false' ? (
                               <img className={classes.off} src="data:image/png;base64,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" alt="offline" />
                            ) : (
                                ''
                            )}
                            </div>
                        <TransformComponent
                            wrapperClass={`${classes.testWrapper} ${
                                authCtx.shareMode &&
                                classes.transformComponentShareMode
                            }`}
                        >
                            <div
                                ref={ref2}
                                className={classes.grid}
                                onMouseDown={() => {
                                    setIsPanning(false)
                                    panningRef.current = setTimeout(() => {
                                        setIsPanning(true)
                                    }, 100)
                                }}
                                onMouseUp={() => {
                                    clearTimeout(panningRef.current)
                                }}
                            >
                                <div className={classes.borderWrapTop}>
                                    <div
                                        className={`${classes.border} ${classes.top}`}
                                    >
                                        {getBorders[0].array}
                                    </div>
                                </div>
                                <div className={classes.borderWrapBottom}>
                                    <div
                                        className={`${classes.border} ${classes.bottom}`}
                                    >
                                        {getBorders[1].array}
                                    </div>
                                </div>
                                <div className={classes.borderWrapLeft}>
                                    <div className={`${classes.left}`}>
                                        {getBorders[2].array}
                                    </div>
                                </div>
                                <div className={classes.borderWrapRight}>
                                    <div className={`${classes.right}`}>
                                        {getBorders[3].array}
                                    </div>
                                </div>
                                {props.hexagons?.map((item) => (
                                    <HexagonItem
                                        isMobile={isMobile}
                                        dropZoneIndex={dropZoneIndex}
                                        setDropZoneIndex={setDropZoneIndex}
                                        swapHexagons={props.swapHexagons}
                                        popupHandler={popupHandler}
                                        multiCopyHandler={
                                            props.multiCopyHandler
                                        }
                                        copyContentDataHandler={
                                            props.copyContentDataHandler
                                        }
                                        contentHandler={props.contentHandler}
                                        setActive={props.setActive}
                                        activeColor={props.activeColor}
                                        // cursorHandler={props.setCursor}
                                        index={item.index}
                                        content={item.content}
                                        active={item.active}
                                        color={item.color}
                                        key={item.id}
                                        bold={item.bold}
                                        italic={item.italic}
                                        hexP={item.hexP}
                                        hexX={item.hexX}
                                        hexY={item.hexY}
                                        init={item.init}
                                        golden={item.golden}
                                        panningHandler={panningHandler}
                                        panningDisabled={panningDisabled}
                                        isPanning={isPanning}
                                        panningGrid={props.panningGrid}
                                        zoomTo={zoomToElement}
                                        transformState={state}
                                        setTransform={setTransform}
                                        scale={state.scale}
                                    />
                                ))}
                            </div>
                        </TransformComponent>
                    </React.Fragment>
                )}
            </TransformWrapper>
            {popupActive && (
                <div onClick={popupHandler} className={`${classes.popup}`}>
                    <div className={`${classes.popupWithClose}`}>
                        <Close closeHandler={popupHandler} />
                        <Hexagon popup={'popup'}>
                            You&apos;ve hit the character limit. Summarise it
                            further to fit into one hexagon, or break your idea
                            down into component parts and use more than one
                            hexagon.
                        </Hexagon>
                    </div>
                </div>
            )}
        </section>
    )
})

HexagonBoard.displayName = 'HexagonBoard'

HexagonBoard.propTypes = {
    hexagons: PropTypes.array,
    multiCopyHandler: PropTypes.func,
    contentHandler: PropTypes.func,
    activeColor: PropTypes.string,
    setActive: PropTypes.func,
    copyContentDataHandler: PropTypes.func,
    swapHexagons: PropTypes.func,
    panningGrid: PropTypes.bool,
}

export default HexagonBoard
